import { render, staticRenderFns } from "./RecommendClassTable.vue?vue&type=template&id=00fd1b23"
import script from "./RecommendClassTable.vue?vue&type=script&lang=js"
export * from "./RecommendClassTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports